import { MiniChips } from "@website/ui/mini-chips";
import { RadioGroup } from "@website/ui/radio-group";
import { deepOmit } from "@website/utils/deep-omit";
import { isFilled } from "@website/utils/is-filled";
import { RadioTypes } from "@website/widget/filter/filter.types";
import styles from "@website/widget/filter/index.module.scss";
import { useRouter } from "next/router";

interface RadioProperties extends RadioTypes {
  name: string;
}

export const RadioFilter = ({
  name,
  title,
  description,
  defaultValue,
  items,
  isNew
}: RadioProperties) => {
  const router = useRouter();

  const { [name]: queryValue } = router.query as Record<string, string>;
  const value = String(queryValue || defaultValue);

  function onChange({ target: { value } }: { target: { value: string } }) {
    router.replace(
      {
        query: deepOmit(
          {
            ...router.query,
            [name]: value === defaultValue ? undefined : value
          },
          isFilled
        )
      },
      undefined,
      { shallow: true, scroll: false }
    );
  }

  return (
    <div className={styles["radio-filter-container"]}>
      <div className="grid grid-cols-3 items-center justify-start gap-2 whitespace-nowrap">
        <div className={styles["filter-header"]} id="has-availability">
          {title}
        </div>
        {description && (
          <span className={styles["has-availability"]}>{description}</span>
        )}
        {isNew && (
          <MiniChips color="primary" text="جدید" variant="round-contained" />
        )}
      </div>
      <RadioGroup
        className="w-full flex-col !items-start"
        color="secondary"
        itemClassName={`${
          process.env["NEXT_PUBLIC_BASE_PATHNAME"]?.includes("رزرو-هتل") ||
          process.env["NEXT_PUBLIC_BASE_PATHNAME"]?.includes("villa")
            ? "!text-body-2"
            : "text-subtitle-2"
        }`}
        items={items}
        radioClassName="!w-full !flex !justify-between"
        name={name}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};
